import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { APP_STORE } from '@app/stores/app.store';

export const DEFAULT_ROUTE_GUARD: CanActivateFn = () => {
  const router = inject(Router);
  const appStore = inject(APP_STORE);

  const clientId = appStore.selectedClientId();
  const reportId = appStore.selectedReportId();

  if (clientId && reportId) {
    return router.createUrlTree([clientId, reportId, 'main']);
  }

  return true;
};
